module.exports = __webpack_public_path__ + "dashboard/img/doublebrackets_right.a5d7612cd165dcec1a642be30a45acd1.svg";